<template>
  <v-container fluid>
    <h1>{{ get("header-1") }}</h1>
    <br />
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-img :src="image" class="image" alt="Siding Image" left></v-img>
        </v-row>
        <v-row>
          <p>
            {{ get("p-1.1") }}
          </p>
        </v-row>
        <v-row :class="theme + '-alt-background-1'">
          <ul>
            <li>
              <strong>{{ get("p-1.2") }}</strong>
              {{ get("p-1.3") }}
            </li>
            <li>
              <strong>{{ get("p-1.4") }}</strong>
              {{ get("p-1.5") }}
            </li>
            <li>
              <strong>{{ get("p-1.6") }}</strong>
              {{ get("p-1.7") }}
            </li>
            <li>
              <strong>{{ get("p-1.8") }}</strong>
              {{ get("p-1.9") }}
            </li>
          </ul>
        </v-row>
        <h2>{{ get("header-2") }}</h2>
        <p>
          {{ get("p-2.1") }}
           <phonenumber phone="(719) 390-7663"></phonenumber> 
          {{ get("p-2.2") }}
        </p>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
import localizationMixin from "@/mixins/localization-mixin";
import phonenumber from "@/components/controls/phone-number";
export default {
  name: "siding-options",

  components: {
    estimate,
    phonenumber
  },

  created() {
    this.pageName = "siding-options";
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  data: () => ({
    image: require("@/assets/siding-5.jpg"),
  }),

  mixins: [localizationMixin],

  methods: {
    getLocalization(){}
  },
};
</script>

<style lang="scss" scoped>
.image {
  margin-bottom: 20px;
}
</style>
